import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5cd1e95b&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=5cd1e95b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1e95b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd1e95b')) {
      api.createRecord('5cd1e95b', component.options)
    } else {
      api.reload('5cd1e95b', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=5cd1e95b&scoped=true&", function () {
      api.rerender('5cd1e95b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/SideBar.vue"
export default component.exports